import _ from 'lodash'
import { Route, NavigationGuard } from 'vue-router'
import store from '@/store'
import JWTToken from '@/modules/auth/types'
import { AxiosAdapter, AxiosRequestConfig } from 'axios'

/**
 * Guardia de navegación para la autorización
 *
 * @param to
 * @param from
 * @param next
 */
export const authGuard: NavigationGuard = async (to, from, next) => {
    const authRequired = _.get(to, 'meta.authRequired', false)

    if (!authRequired) {
        next()

        return
    }

    const token: JWTToken | null = await store.dispatch('auth/loadToken')
    if (!token || !token.isValid) {
        next({ name: 'login' })

        return
    }

    next()
}

export const authInterceptor = async (config: AxiosRequestConfig) => {
    const token: JWTToken = await store.dispatch('auth/loadToken')
    config.headers.Authorization = `Bearer ${token.encoded}`

    return config
}
